import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_vintage_holiday: FaireCollectionEntity = {
  token: "col_vintage-holiday",
  type: "collection",
  name: "Vintage Holiday",
  description:
    "Santa Claus is comin' to town! Make it a vintage Christmas with decor that adds instant cheer, holiday charm, and nostalgia all in one.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1512389142860-9c449e58a814?w=400&h=400&fit=crop",
  heroImageUrl:
    "https://images.unsplash.com/photo-1512389142860-9c449e58a814?w=1200&h=600&fit=crop",
  season: "winter",
  itemCount: 36,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
